module.exports = __webpack_public_path__ + "assets/ganenjie.0b7a1888.svg";